/**
 * Ops session helper — small module used by /ops UI to store/retrieve the
 * bearer token issued by /api/ops/auth/verify, and to check whether the user
 * is currently authenticated.
 */
const KEY = "ops_session_token";
const EXP = "ops_session_expires_at";

export function getOpsToken() {
  try {
    const t = localStorage.getItem(KEY);
    const e = localStorage.getItem(EXP);
    if (!t) return null;
    if (e && new Date(e).getTime() < Date.now()) {
      localStorage.removeItem(KEY);
      localStorage.removeItem(EXP);
      return null;
    }
    return t;
  } catch (_) {
    return null;
  }
}

export function setOpsToken(token, expiresAt) {
  try {
    localStorage.setItem(KEY, token);
    if (expiresAt) localStorage.setItem(EXP, expiresAt);
  } catch (_) { /* ignore */ }
}

export function clearOpsToken() {
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem(EXP);
  } catch (_) { /* ignore */ }
}

export function opsAuthHeader() {
  const t = getOpsToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}
